import { graphql } from 'common/actions/apiAction';

export const START_GET_NETWORKS = 'START_GET_NETWORKS';
export const COMPLETE_GET_NETWORKS = 'COMPLETE_GET_NETWORKS';

export function startGetNetworks() {
    return {
        type: START_GET_NETWORKS,
        startTime: Date.now()
    };
}

export function completeGetNetworks(networks) {
    return {
        type: COMPLETE_GET_NETWORKS,
        completeTime: Date.now(),
        networks
    };
}

export function fetchNetworks() {
    return async (dispatch) => {
        dispatch(startGetNetworks());

        let networks = [];
        try {
            const response = await dispatch(graphql('getNetworks'));
            networks = response.data.networks;
        } catch (err) {
            console.error(err);
        }

        dispatch(completeGetNetworks(networks));

        return networks;
    };
}



// WEBPACK FOOTER //
// ./app/common/actions/networkActions.js